import { useTranslation } from 'react-i18next';

import { CREATIVE_CATEGORY, CreativeCategory } from '@features/campaigns/builder/types/creativeType.ts';
import { i18nNameSpace } from '@shared/consts/i18n';

import styles from './NoImages.module.scss';

interface NoCreativesProps {
  creativeCategory: CreativeCategory;
}

function determineInfoTextKey(creativeCategory: CreativeCategory) {
  switch (creativeCategory) {
    case CREATIVE_CATEGORY.IMAGE:
      return 'builder.formFields.common.noImages';
    case CREATIVE_CATEGORY.VIDEO:
      return 'builder.formFields.common.noVideo';
    default:
      return 'builder.formFields.common.noImages';
  }
}

export function NoCreatives({ creativeCategory }: NoCreativesProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const infoTextKey = determineInfoTextKey(creativeCategory);

  return (
    <div className={styles.noImages} data-testid={`no-creatives-${creativeCategory}`}>
      {t(infoTextKey)}
    </div>
  );
}
